module.exports = __webpack_public_path__ + "static/p-miftah-123d716eea8cc802d854c0987ec90efe.jpg";